import {
  MarketingCampaignDoc,
  MarketingCampaignCTA,
  MarketingCampaignSecondaryCTA,
  MarketingCampaignAsset,
} from "@pollyslack/hub/src/types";
import { get, post } from "./rest";

const root = "/campaigns/content";

export async function getConfig(): Promise<{
  campaignBuilderEnabled: boolean;
}> {
  return await get(`${root}/config`);
}

export async function listCampaigns(
  status?: string,
): Promise<MarketingCampaignDoc[]> {
  const query = status ? `?status=${status}` : "";
  return await get(`${root}${query}`);
}

export async function getCampaign(id: string): Promise<MarketingCampaignDoc> {
  return await get(`${root}/${id}`);
}

export async function createCampaign(params: {
  identifier: string;
  headerText: string;
  bodyMrkdwn: string;
  primaryCTA: MarketingCampaignCTA;
  asset?: MarketingCampaignAsset;
  secondaryCTA?: MarketingCampaignSecondaryCTA;
  demoUrl?: string;
}): Promise<MarketingCampaignDoc> {
  return await post(root, params);
}

export async function updateCampaign(
  id: string,
  params: {
    /** Only accepted while the campaign is a draft */
    identifier?: string;
    headerText?: string;
    bodyMrkdwn?: string;
    primaryCTA?: MarketingCampaignCTA;
    asset?: MarketingCampaignAsset | null;
    secondaryCTA?: MarketingCampaignSecondaryCTA | null;
    demoUrl?: string | null;
  },
): Promise<MarketingCampaignDoc> {
  return await post(`${root}/${id}/update`, params);
}

export async function activateCampaign(
  id: string,
): Promise<MarketingCampaignDoc> {
  return await post(`${root}/${id}/activate`);
}

export async function archiveCampaign(
  id: string,
): Promise<MarketingCampaignDoc> {
  return await post(`${root}/${id}/archive`);
}

export interface TestRecipient {
  mongoId: string;
  orgId: string;
  teamId: string;
  slackUserId: string;
  realName?: string;
  displayName?: string;
  email?: string;
}

export async function getTestRecipient(
  mongoId: string,
): Promise<TestRecipient> {
  return await get(`${root}/test-recipient/${encodeURIComponent(mongoId)}`);
}

export async function testCampaign(
  id: string,
  mongoId: string,
): Promise<{
  status?: string;
  recipient?: { mongoId: string; slackUserId: string; email?: string };
  // rest.ts's post() throws on any non-2xx, so these shouldn't appear on a
  // resolved payload in practice — kept as defense in depth (PS-5699).
  error?: string;
  message?: string;
}> {
  return await post(`${root}/${id}/test`, { mongoId });
}

export async function getCTAOptions(): Promise<{
  primaryCTATypes: { key: string; value: string }[];
  dropdownOptions: { key: string; value: string }[];
}> {
  return await get(`${root}/cta-options`);
}

export async function getActiveIdentifiers(): Promise<
  { identifier: string; headerText: string }[]
> {
  return await get(`${root}/active-identifiers`);
}
